import { Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[apFormFocus]',
})
export class ApFormFocusDirective {

  constructor(private el: ElementRef) { }

  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid.form-control');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }
}
